import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { FullPageLoading } from "../components/utils/Loading";
import { RootState } from "../store";
import { buildLoginPath } from "../utils/authReturnUrl";

function PrivateRoute({ children }: any) {
  const loading = useSelector((state: RootState) => state.session.loading);
  const accessToken = useSelector(
    (state: RootState) => state.session.accessToken
  );
  const currentUser = useSelector(
    (state: RootState) => state.session.currentUser
  );
  const location = useLocation();
  // Adds nessecary authorization headers to API requests.

  if (accessToken && currentUser?.id) {
    return children;
  } else if (loading) {
    return <FullPageLoading />;
  } else if (!accessToken && !loading) {
    const returnPath = `${location.pathname}${location.search}`;
    const loginPath = buildLoginPath(returnPath);
    return (
      <Navigate to={loginPath} state={{ from: location }} replace />
    );
  } else {
    return <p>Something went wrong</p>;
  }
}

export default PrivateRoute;
